import { render, staticRenderFns } from "./creative-form.vue?vue&type=template&id=8732f160&scoped=true"
import script from "./creative-form.vue?vue&type=script&setup=true&lang=js"
export * from "./creative-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./creative-form.vue?vue&type=style&index=0&id=8732f160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8732f160",
  null
  
)

export default component.exports